var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"d-flex submenu-category-title"},'div',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{staticClass:"submenu-list-icon",attrs:{"size":"22","color":"text"}},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"w-body-1 my-auto"},[(_vm.title)?_c('div',[_vm._v(_vm._s(_vm.title))]):_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }